const booksData = [
  {
    id: "live",
    title: "Value-based Stories & Activities",
    value: "All-in-One",
    tagline:
      "Our very first storybook — value-based stories and fun activities kids can read, play and grow with.",
    isLive: true,
    price: "₹499",
    amazonLink:
      "https://www.amazon.in/dp/9334352930?ref_=cm_sw_r_ffobk_cso_wa_apan_dp_WJQRMNF59VM2RRRQ7S97&bestFormat=true",
    images: [
      "/images/books/live/cover.webp",
      "/images/books/live/back.webp",
    ],
  },
  {
    id: "honesty",
    title: "Meendu Spies Honesty",
    value: "Honesty",
    tagline: "Meendu learns why telling the truth always wins the day.",
    description:
      "Meendu learns why telling the truth always wins the day. Part of the Meendu Spies series — bite-sized value stories paired with fun activities that help kids connect honesty to everyday moments at home and school.",
    isLive: true,
    amazonLink: "https://amzn.in/d/00ebKJL3",
    images: [
      "/images/books/honesty/honesty-1.webp",
      "/images/books/honesty/honesty-2.webp",
      "/images/books/honesty/honesty-3.webp",
      "/images/books/honesty/honesty-4.webp",
      "/images/books/honesty/honesty-5.webp",
    ],
  },
  {
    id: "kindness",
    title: "Meendu Spies Kindness",
    value: "Kindness",
    tagline: "A gentle story about small acts of kindness that matter big.",
    description:
      "A gentle story about small acts of kindness that matter big. Part of the Meendu Spies series — bite-sized value stories paired with fun activities that help kids notice everyday chances to be kind.",
    isLive: false,
    images: [
      "/images/books/kindness/kindness-1.webp",
      "/images/books/kindness/kindness-2.webp",
      "/images/books/kindness/kindness-3.webp",
      "/images/books/kindness/kindness-4.webp",
    ],
  },
  {
    id: "patience",
    title: "Meendu Spies Patience",
    value: "Patience",
    tagline: "Meendu discovers that good things come to those who wait.",
    description:
      "Meendu discovers that good things come to those who wait. Part of the Meendu Spies series — bite-sized value stories paired with fun activities that help kids practice patience in everyday situations.",
    isLive: false,
    images: [
      "/images/books/patience/patience-1.webp",
      "/images/books/patience/patience-2.webp",
      "/images/books/patience/patience-3.webp",
      "/images/books/patience/patience-4.webp",
      "/images/books/patience/patience-5.webp",
    ],
  },
  {
    id: "helpfulness",
    title: "Meendu Spies Helpfulness",
    value: "Helpfulness",
    tagline: "A heartwarming tale about lending a helping hand to others.",
    description:
      "A heartwarming tale about lending a helping hand to others. Part of the Meendu Spies series — bite-sized value stories paired with fun activities that help kids see how small acts of help can make a big difference.",
    isLive: false,
    images: [
      "/images/books/helpfulness/helpfulness-1.webp",
      "/images/books/helpfulness/helpfulness-2.webp",
      "/images/books/helpfulness/helpfulness-3.webp",
      "/images/books/helpfulness/helpfulness-4.webp",
    ],
  },
];

export default booksData;
